import {useState, useEffect} from 'react';
import { Grid, Typography, Button } from '@mui/material';
import { useSelector } from 'react-redux';
import ViewPOActionImpl from 'components/po/action/viewPO/ViewPOActionImpl';
import PoSelectionMgmtPoList from './PoSelectionMgmtPoList';
import PoSelectionList from 'components/po/components/PoSelectionList';

export default function PoSelectionMgmt(){
    const {poObj} = useSelector((state)=>state.pharmaslice.poDashboard);

    return (
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        >
            <Grid item lg={7} xs={12}>
                <ViewPOActionImpl />
            </Grid>
            <Grid item lg={5} xs={12}>
                <PoSelectionMgmtPoList/>
                {/* <PoSelectionList/> */}
            </Grid>
        </Grid>
    )
}